(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 92148:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(67637);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ List_List; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/color-mode/color-mode-context.mjs
var color_mode_context = __webpack_require__(18850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/grid/simple-grid.mjs
var simple_grid = __webpack_require__(19694);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/h-stack.mjs
var h_stack = __webpack_require__(542);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(69224);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/badge/badge.mjs
var badge_badge = __webpack_require__(74352);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(55521);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/shared/List/ListItem.tsx






const ListItem = (_param)=>{
    var { href , badge , icon , children  } = _param, chakraProps = (0,_object_without_properties/* default */.Z)(_param, [
        "href",
        "badge",
        "icon",
        "children"
    ]);
    const { colorMode  } = (0,color_mode_context/* useColorMode */.If)();
    const isDarkmode = colorMode === "dark";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                p: 4,
                as: "a",
                bg: isDarkmode ? "grey.3" : "grey.1",
                borderRadius: "xl",
                _hover: {
                    bg: isDarkmode ? "grey.4" : "grey.2"
                },
                _active: {
                    bg: isDarkmode ? "grey.5" : "grey.3"
                }
            }, chakraProps), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                        w: "1.5em",
                        h: "1.5em",
                        bg: "grey.1",
                        borderRadius: "lg",
                        lineHeight: "1.5em",
                        textAlign: "center",
                        children: icon
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                        flexGrow: 1,
                        noOfLines: 1,
                        children: children
                    }),
                    badge && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(badge_badge/* Badge */.C, {
                        letterSpacing: "wide",
                        color: "grey.11",
                        bg: "grey.1",
                        children: badge
                    })
                ]
            }))
        })
    });
};
/* harmony default export */ var List_ListItem = (ListItem);

;// CONCATENATED MODULE: ./src/components/shared/List/List.tsx






const List = (_param)=>{
    var { children  } = _param, chakraProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    const { colorMode  } = (0,color_mode_context/* useColorMode */.If)();
    const isDarkmode = colorMode === "dark";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(simple_grid/* SimpleGrid */.M, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "ul",
        listStyleType: "none",
        gap: 2,
        bg: isDarkmode ? "grey.1" : "grey.4",
        p: 2,
        borderRadius: "22"
    }, chakraProps), {
        children: children
    }));
};
List.Item = List_ListItem;
/* harmony default export */ var List_List = (List);

;// CONCATENATED MODULE: ./src/components/shared/List/index.ts



/***/ }),

/***/ 88362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48512);
/* harmony import */ var _components_shared_Motion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47474);
/* harmony import */ var _components_shared_PlayerAvatar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81228);
/* harmony import */ var _components_shared_PointIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60135);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7809);
/* harmony import */ var _lib_types_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88795);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(542);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69224);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74352);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63997);








const Side = (param)=>{
    let { label , players , isReverse , isSelected , onClick , emptySlots =0  } = param;
    const paddingAvatars = emptySlots > 0 ? new Array(emptySlots).fill({
        id: "0",
        name: "+"
    }) : [];
    const teamAveragePoints = players ? Math.ceil((players === null || players === void 0 ? void 0 : players.reduce((acc, cur)=>{
        var ref, ref1;
        return acc + (cur && (0,_lib_types_utils__WEBPACK_IMPORTED_MODULE_4__/* .hasKey */ .wH)(cur, "scores") && ((ref = cur.scores) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.points) || _constants__WEBPACK_IMPORTED_MODULE_3__/* .STARTING_POINTS */ .G5);
    }, 0)) / (players === null || players === void 0 ? void 0 : players.length)) || 0 : 0;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
        as: "button",
        type: "button",
        flex: 1,
        bg: isSelected ? "grey.4" : undefined,
        transition: ".3s ease-in-out",
        borderRadius: "xl",
        p: 2,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .U, {
                flexFlow: isReverse ? "row-reverse" : undefined,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .x, {
                    as: "h2",
                    color: isSelected ? "grey.12" : "grey.10",
                    fontWeight: "bold",
                    children: label
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .U, {
                flexFlow: isReverse ? "row-reverse" : undefined,
                spacing: 0,
                minH: "76px",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .AnimatePresence */ .M, {
                    initial: false,
                    children: [
                        players === null || players === void 0 ? void 0 : players.map((player, index)=>/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_shared_Motion__WEBPACK_IMPORTED_MODULE_0__/* .MotionBox */ .u, {
                                flex: 1,
                                maxW: "25%",
                                ml: isReverse ? -2 : 0,
                                mr: isReverse ? 0 : -2,
                                zIndex: paddingAvatars.length + players.length - index,
                                layout: true,
                                initial: {
                                    scale: 0
                                },
                                animate: {
                                    scale: 1
                                },
                                exit: {
                                    scale: 0
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_shared_PlayerAvatar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    user: player,
                                    size: "100%"
                                })
                            }, index)),
                        paddingAvatars.map((_, index)=>{
                            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_shared_Motion__WEBPACK_IMPORTED_MODULE_0__/* .MotionBox */ .u, {
                                flex: 1,
                                maxW: "25%",
                                ml: isReverse ? -2 : 0,
                                mr: isReverse ? 0 : -2,
                                zIndex: paddingAvatars.length - index,
                                layout: true,
                                initial: {
                                    scale: 0
                                },
                                animate: {
                                    scale: 1
                                },
                                exit: {
                                    scale: 0
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                                    bg: "grey.3",
                                    pb: "100%",
                                    w: "100%",
                                    h: "0",
                                    borderRadius: "full",
                                    position: "relative",
                                    boxShadow: "0 0 0 3px var(--wrkplay-colors-grey-4)",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                                        position: "absolute",
                                        inset: "0",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "2xl",
                                        lineHeight: 1,
                                        color: "grey.10",
                                        children: "+"
                                    })
                                })
                            }, ((players === null || players === void 0 ? void 0 : players.length) || 0) + index);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .U, {
                mt: 2,
                flexFlow: isReverse ? "row-reverse" : undefined,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Badge */ .C, {
                    variant: "subtle",
                    colorScheme: "grey",
                    bg: "grey.1",
                    children: [
                        teamAveragePoints,
                        " ",
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_shared_PointIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            bg: "grey.8"
                        }),
                        " ",
                        ((players === null || players === void 0 ? void 0 : players.length) || 0) > 1 ? "avg." : " "
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Side);


/***/ }),

/***/ 88795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m2": function() { return /* binding */ hasProp; },
/* harmony export */   "wH": function() { return /* binding */ hasKey; }
/* harmony export */ });
/* unused harmony export getExactTypeFor */
function hasProp(data, prop) {
    return prop in data;
}
function hasKey(obj, key) {
    return key in obj;
}
const getExactTypeFor = ()=>(inputOutput)=>inputOutput;


/***/ }),

/***/ 67637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./src/components/shared/SEO/index.ts + 1 modules
var SEO = __webpack_require__(10923);
// EXTERNAL MODULE: ./src/lib/navigationHistory/useNavigationState.ts
var useNavigationState = __webpack_require__(25094);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/container/container.mjs
var container = __webpack_require__(83658);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/grid/simple-grid.mjs
var simple_grid = __webpack_require__(19694);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./src/components/shared/Motion/index.tsx
var Motion = __webpack_require__(47474);
// EXTERNAL MODULE: ./src/components/shared/NewMatchButton/Side.tsx
var Side = __webpack_require__(88362);
// EXTERNAL MODULE: ./src/theme/components/Modal.ts
var Modal = __webpack_require__(53051);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/color-mode/color-mode-context.mjs
var color_mode_context = __webpack_require__(18850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/heading.mjs
var heading = __webpack_require__(26801);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/h-stack.mjs
var h_stack = __webpack_require__(542);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/badge/badge.mjs
var badge = __webpack_require__(74352);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/input/input.mjs
var input = __webpack_require__(23918);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(63997);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/system.mjs + 4 modules
var system = __webpack_require__(18645);
;// CONCATENATED MODULE: ./src/components/HomePage/Section.tsx

const Section = (0,system/* styled */.z)(box/* Box */.x, {
    defaultProps: {
        as: "section"
    },
    baseStyle: {
        py: 4,
        bg: "grey.4",
        px: 4,
        borderRadius: "xl",
        position: "relative",
        overflow: "hidden"
    }
});
/* harmony default export */ var HomePage_Section = (Section);

;// CONCATENATED MODULE: ./src/components/HomePage/blocks/AddMatchBlock.tsx










const AddMatchBlock = (param)=>{
    let { players  } = param;
    const { 0: iteration , 1: setIteration  } = (0,react.useState)(0);
    const { 0: step , 1: setStep  } = (0,react.useState)(0);
    const { colorMode  } = (0,color_mode_context/* useColorMode */.If)();
    const { 0: selectedSide , 1: setSelectedSide  } = (0,react.useState)(undefined);
    const { 0: teamsComp , 1: setTeamsComp  } = (0,react.useState)({
        left: [],
        right: []
    });
    const { 0: teamsScores , 1: setTeamsScores  } = (0,react.useState)({
        left: 0,
        right: 0
    });
    const { 0: bgColor , 1: setBgColor  } = (0,react.useState)(false);
    const colors = {
        success: colorMode === "light" ? "success.4" : "success.12",
        danger: colorMode === "light" ? "danger.4" : "danger.12"
    };
    (0,react.useEffect)(()=>{
        if (players) {
            switch(step){
                case 1:
                    setIteration(iteration + 1);
                    setSelectedSide("left");
                    setTeamsComp({
                        left: [],
                        right: []
                    });
                    setTeamsScores({
                        left: 0,
                        right: 0
                    });
                    setBgColor(false);
                    break;
                case 2:
                    setTeamsComp({
                        left: [
                            players === null || players === void 0 ? void 0 : players[0]
                        ],
                        right: []
                    });
                    break;
                case 3:
                    setTeamsComp((comp)=>({
                            left: [
                                ...comp.left,
                                players[2]
                            ],
                            right: []
                        }));
                    break;
                case 4:
                    setSelectedSide("right");
                    break;
                case 5:
                    setTeamsComp((comp)=>{
                        return {
                            left: comp.left,
                            right: [
                                players === null || players === void 0 ? void 0 : players[1]
                            ]
                        };
                    });
                    break;
                case 6:
                    setTeamsComp((comp)=>{
                        return {
                            left: comp.left,
                            right: [
                                ...comp.right,
                                players === null || players === void 0 ? void 0 : players[3]
                            ]
                        };
                    });
                    break;
                case 7:
                    setSelectedSide(undefined);
                    break;
                case 8:
                    setTeamsScores({
                        left: Math.ceil(Math.random() * 8),
                        right: 0
                    });
                    break;
                case 9:
                    setTeamsScores((scores)=>({
                            left: scores.left,
                            right: Math.ceil(Math.random() * 8)
                        }));
                    break;
                case 10:
                    setBgColor(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        step
    ]);
    (0,react.useEffect)(()=>{
        const skipStep = ()=>step < 10 ? setStep((step)=>step + 1) : setStep(0);
        const timeout = setTimeout(skipStep, 500);
        return ()=>clearTimeout(timeout);
    }, [
        step
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HomePage_Section, {
        pb: {
            base: "80%",
            md: "inherit"
        },
        bg: teamsScores.left === teamsScores.right || !bgColor ? undefined : teamsScores.left > teamsScores.right ? colors.success : colors.danger,
        css: {
            perspective: "1000px"
        },
        transition: "background-color .3s ease-in-out",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(heading/* Heading */.X, {
                as: "h2",
                color: "grey.11",
                size: "md",
                p: 4,
                children: "Register any match in less than 30 seconds"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Motion/* MotionBox */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    position: "absolute",
                    initial: {
                        opacity: 0,
                        translateY: 300,
                        rotateY: -40
                    },
                    animate: {
                        opacity: 1,
                        translateY: 0,
                        transition: {
                            duration: 0.5
                        }
                    },
                    exit: {
                        opacity: 0,
                        translateY: -300,
                        transition: {
                            duration: 0.5
                        }
                    }
                }, Modal/* Modal.variants.custom.dialog */.u.variants.custom.dialog), {
                    w: "80%",
                    minW: "300px",
                    left: "10%",
                    top: "25%",
                    p: 4,
                    pointerEvents: "none",
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                            as: "aside",
                            spacing: -1,
                            mb: 4,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Side/* default */.Z, {
                                    label: "Your team",
                                    players: teamsComp.left,
                                    emptySlots: 1,
                                    isReverse: true,
                                    isSelected: selectedSide === "left"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(badge/* Badge */.C, {
                                    variant: "solid",
                                    colorScheme: "danger",
                                    zIndex: "docked",
                                    children: "Vs"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Side/* default */.Z, {
                                    label: "Opposing team",
                                    players: teamsComp.right,
                                    emptySlots: 1,
                                    isSelected: selectedSide === "right"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                            spacing: 8,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                                    flex: 1,
                                    position: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(badge/* Badge */.C, {
                                            position: "absolute",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            zIndex: 2,
                                            children: "Score"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input/* Input */.I, {
                                            as: "div",
                                            py: 4,
                                            h: "auto",
                                            fontSize: "xl",
                                            textAlign: "center",
                                            children: teamsScores.left
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                                    flex: 1,
                                    position: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(badge/* Badge */.C, {
                                            position: "absolute",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            zIndex: 2,
                                            children: "Score"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input/* Input */.I, {
                                            as: "div",
                                            py: 4,
                                            h: "auto",
                                            fontSize: "xl",
                                            textAlign: "center",
                                            children: teamsScores.right
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }), iteration)
            })
        ]
    });
};
/* harmony default export */ var blocks_AddMatchBlock = (AddMatchBlock);

// EXTERNAL MODULE: ./src/components/shared/Leaderboard/index.ts + 4 modules
var Leaderboard = __webpack_require__(95484);
;// CONCATENATED MODULE: ./src/components/HomePage/blocks/LeaderboardBlock.tsx




const LeaderboardBlock = (param)=>{
    let { gameId , seasonId  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HomePage_Section, {
        p: 0,
        pb: "100%",
        w: "100%",
        h: "500px",
        bg: "grey.4",
        display: "flex",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(heading/* Heading */.X, {
                as: "h2",
                color: "grey.11",
                size: "md",
                p: 8,
                zIndex: "1",
                position: "relative",
                children: "Climb up the leaderboards"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                position: "relative",
                css: {
                    perspective: "1000px"
                },
                p: 4,
                flexGrow: "1",
                sx: {
                    maskImage: "linear-gradient(to bottom, rgba(0,0,0,1) calc(100% - 128px), rgba(0,0,0,0))"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                    left: "25%",
                    top: "10%",
                    position: "absolute",
                    w: "100%",
                    zIndex: "0",
                    transform: "rotateY(30deg)",
                    children: gameId && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard/* default */.Z, {
                        gameId: gameId,
                        seasonId: seasonId
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var blocks_LeaderboardBlock = (LeaderboardBlock);

// EXTERNAL MODULE: ./src/components/shared/LatestMatches/index.ts + 7 modules
var LatestMatches = __webpack_require__(83910);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(69224);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/v-stack.mjs
var v_stack = __webpack_require__(10461);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/button/button.mjs + 4 modules
var button_button = __webpack_require__(96756);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-auth@4.24.11_next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@1_acaee22c3ffd625475c47b7b2c959a5f/node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(25096);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dynamic.js
var dynamic = __webpack_require__(71905);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(55521);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/HomePage/blocks/PlayersBlock.tsx







const PlayersDeco = dynamic_default()(()=>__webpack_require__.e(/* import() */ 233).then(__webpack_require__.bind(__webpack_require__, 18233)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18233)
            ]
    },
    ssr: false
});
const PlayersBlock = (param)=>{
    let { players  } = param;
    const { status  } = (0,next_auth_react.useSession)();
    const isLoggedIn = status === "authenticated";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HomePage_Section, {
                gridColumn: "1/-1",
                pb: 0,
                transform: "translateZ(0)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                        h: "100%",
                        w: "100%",
                        top: "0",
                        left: "0",
                        position: "absolute",
                        bg: "grey.4",
                        zIndex: "2",
                        pointerEvents: "none",
                        sx: {
                            maskImage: "linear-gradient(to bottom, rgba(0,0,0,0) 75%, rgba(0,0,0,1))"
                        },
                        borderBottomRadius: "xl"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayersDeco, {
                        players: players
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                        zIndex: 1,
                        position: "relative",
                        css: {
                            perspective: "1000px"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(heading/* Heading */.X, {
                                as: "h2",
                                mb: 12,
                                mt: 4,
                                textAlign: "center",
                                color: "grey.10",
                                size: "lg",
                                children: [
                                    "join",
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                        as: "span",
                                        color: "primary.9",
                                        children: "heaps"
                                    }),
                                    " ",
                                    "of",
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                        as: "span",
                                        display: "inline-block",
                                        position: "relative",
                                        _before: {
                                            content: '""',
                                            position: "absolute",
                                            w: "100%",
                                            h: ".08em",
                                            bg: "primary.9",
                                            top: "58%",
                                            left: 0
                                        },
                                        children: "unproductive"
                                    }),
                                    " ",
                                    "great players"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                                "aria-hidden": "true",
                                pointerEvents: "none",
                                h: "400px",
                                overflow: "hidden",
                                maxW: "container.sm",
                                mx: "auto",
                                pt: 8,
                                transform: "rotateX(30deg)",
                                transformOrigin: "bottom",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LatestMatches/* default */.Z, {
                                    canLoadMore: false,
                                    canDelete: false
                                })
                            })
                        ]
                    })
                ]
            }),
            !isLoggedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v_stack/* VStack */.g, {
                transform: "translateY(-50%)",
                mt: -4,
                position: "relative",
                zIndex: "2",
                gridColumn: "1/-1",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/auth/signin",
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_button/* Button */.z, {
                        as: "a",
                        variant: "primary",
                        size: "lg",
                        m: 3,
                        children: "Sign in to play"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var blocks_PlayersBlock = (PlayersBlock);

// EXTERNAL MODULE: ./src/lib/styleUtils.ts
var styleUtils = __webpack_require__(25198);
// EXTERNAL MODULE: ./src/components/shared/List/index.ts + 2 modules
var List = __webpack_require__(99809);
;// CONCATENATED MODULE: ./src/components/HomePage/Hero.tsx




const Hero = (param)=>{
    let { offices  } = param;
    const officesWithGames = (offices === null || offices === void 0 ? void 0 : offices.filter((office)=>office.games.length)) || [];
    var _icon;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(container/* Container */.W, {
        maxW: "container.xl",
        px: {
            base: 4,
            lg: 8
        },
        position: {
            md: "sticky"
        },
        top: "0",
        zIndex: "0",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(simple_grid/* SimpleGrid */.M, {
            mx: "auto",
            columns: {
                lg: 2
            },
            gap: 8,
            alignItems: "center",
            minH: "90vh",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                    pt: 32,
                    pb: 16,
                    textAlign: {
                        base: "center",
                        lg: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(heading/* Heading */.X, {
                            as: "h1",
                            fontSize: {
                                base: "5rem",
                                md: "6rem"
                            },
                            lineHeight: "1",
                            letterSpacing: "tighter",
                            color: "grey.11",
                            mb: 8,
                            children: [
                                "work hard,",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                    as: "span",
                                    bg: styleUtils/* gradientProps */.K3,
                                    backgroundClip: "text",
                                    children: "play hard."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(typography_text/* Text */.x, {
                            color: "grey.11",
                            maxW: "44ch",
                            mb: 4,
                            mx: {
                                base: "auto",
                                lg: 0
                            },
                            children: [
                                "Get your personal OKRs ready: workplay (pun very intended) enables you to show off your skills outside the office. ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                "A way more interesting way to",
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                    as: "span",
                                    whiteSpace: "nowrap",
                                    children: "1-on-1"
                                }),
                                "."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                    py: 8,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(heading/* Heading */.X, {
                            as: "h2",
                            mb: 4,
                            fontSize: "md",
                            color: "grey.10",
                            pl: {
                                lg: 14
                            },
                            textAlign: {
                                base: "center",
                                lg: "left"
                            },
                            children: "Explore games in"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* default */.Z, {
                            "data-testid": "hero-offices",
                            columns: {
                                lg: officesWithGames.length > 4 ? 2 : 1
                            },
                            children: officesWithGames.map((office)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* default.Item */.Z.Item, {
                                    href: "/".concat(office.slug),
                                    icon: (_icon = office.icon) !== null && _icon !== void 0 ? _icon : undefined,
                                    badge: "".concat(office.games.length, " game").concat(office.games.length !== 1 ? "s" : ""),
                                    children: office.name
                                }, office.slug))
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var HomePage_Hero = (Hero);

;// CONCATENATED MODULE: ./src/components/HomePage/HomePage.tsx








const HomePage = (param)=>{
    let { offices , players , mostRecentGame  } = param;
    (0,useNavigationState/* default */.Z)("Offices");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SEO/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomePage_Hero, {
                offices: offices
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(container/* Container */.W, {
                bg: "grey.2",
                position: "relative",
                maxW: "container.xl",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(simple_grid/* SimpleGrid */.M, {
                    columns: {
                        md: 2
                    },
                    gap: 4,
                    children: [
                        mostRecentGame.gameId && mostRecentGame.seasonId && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(blocks_LeaderboardBlock, {
                            gameId: mostRecentGame.gameId
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(blocks_AddMatchBlock, {
                            players: players
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(blocks_PlayersBlock, {
                            players: players
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var HomePage_HomePage = (HomePage);

;// CONCATENATED MODULE: ./src/components/HomePage/index.ts


;// CONCATENATED MODULE: ./src/pages/index.tsx

var __N_SSG = true;
/* harmony default export */ var pages = (HomePage_HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [600,149,393,484,774,888,179], function() { return __webpack_exec__(92148); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);